import { Storage } from "./storage";

class SessionStorage extends Storage {
    constructor() {
        super("sessionStorage");
    }
}

const sessionStorage = new SessionStorage();

export default sessionStorage;